<script setup lang="ts">
  import { ref } from "vue";

  const downloadRef = ref();
</script>

<template>
  <div ref="downloadRef" class="tw-relative">
    <a-tooltip
      overlay-class-name="qrcodeOverlay"
      placement="bottom"
      trigger="click"
      :get-popup-container="() => downloadRef">
      <template #title>
        <div class="qrcode-box">
          <div class="qrcode-wrap">
            <img class="qrcode" src="~/assets/images/qrcode/paralegal.png" />
            <span>扫码下载</span>
            <span>得理律助APP</span>
          </div>
          <div class="qrcode-wrap">
            <img class="qrcode" src="~/assets/images/qrcode/legal-search.png" />
            <span>扫码下载</span>
            <span>得理法搜APP</span>
          </div>
        </div>
      </template>
      <slot>--</slot>
    </a-tooltip>
  </div>
</template>

<style lang="less" scoped>
  :deep(.qrcodeOverlay) {
    top: 50px !important;
    max-width: none;

    .ant-tooltip-arrow::before {
      background-color: #fff;
    }

    .ant-tooltip-inner {
      width: fit-content;
      padding: 20px 34px 12px;
      background-color: #fff;
      border-radius: 10px;

      .qrcode-box {
        display: flex;

        .qrcode-wrap {
          display: flex;
          flex-direction: column;
          align-items: center;

          .qrcode {
            width: 110px;
            height: 110px;
            padding: 6px;
            margin-bottom: 8px;
            border: 1px solid #b9c5d2;
            border-radius: 8px;
          }

          span {
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            color: #23343c;
          }

          &:nth-child(1) {
            margin-right: 32px;
          }
        }
      }
    }
  }
</style>
